function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext, forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing4, spacing8, spacing16, text120 } from "@churchofjesuschrist/eden-style-constants";
import { InternalUseOnlyHint } from "./Hint";
import { InternalUseOnlyLabel } from "./Label";
import { InternalUseOnlyLegend } from "./Legend";
import { ValidityStateContext } from "./validityState";
const Container = styled.fieldset.withConfig({
  componentId: "sc-1e7bazx-0"
})(["display:block;border:none;padding:0;"]);
const InnerContainer = styled.div.withConfig({
  componentId: "sc-1e7bazx-1"
})(["display:inline-block;& > ", "{margin-block-end:", ";}", " + ", ",", " + ", "{padding-block-start:", ";}& > ", "{display:flex;gap:", ";align-items:flex-start;color:", ";}& > ", "{margin-block-start:", ";}"], InternalUseOnlyLegend, spacing16, InternalUseOnlyLabel, InternalUseOnlyLabel, InternalUseOnlyHint, InternalUseOnlyLabel, spacing16, InternalUseOnlyLabel, spacing8, text120, InternalUseOnlyHint, spacing4);
/**
 * The FieldSet is used to group several controls such as radio inputs and checkboxes.
 */

const FieldSet = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    validityState,
    ...props
  } = _ref;
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(ValidityStateContext.Provider, {
    value: validityState ? validityState : validityStateContext
  }, /*#__PURE__*/React.createElement(InnerContainer, null, children)));
});
FieldSet.displayName = "FieldSet";
FieldSet.propTypes = {
  /** The current validity state of the FieldSet */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),

  /** Content to render inside the FieldSet Component */
  children: PropTypes.node.isRequired
};
export default FieldSet;